import { Th, Thead, Tr } from "@chakra-ui/react"

import { StyledTh } from "./TableStyles"

const TableHeader = ({ columns, extraCols = 0, isReportsPage }: any) => {

  const renderExtraCols = () =>
    Array.from({ length: extraCols }, (_v, i: number) => (
      <StyledTh key={i} />
    ))

  const renderTh = (props: any) => {
    return isReportsPage ? <Th
      style={{
        fontWeight: "bold",
        color: "black",
        fontSize: "13px",
        height: "80px",
        wordWrap: "break-word",
        whiteSpace: "normal",
        backgroundColor: "#86cdf0",
        padding: 5,
        margin: 0
      }}
      key={props.key}>{props.label || ""}</Th> :
      <StyledTh key={props.key}>{props.label || ""}</StyledTh>
  }

  return (
    <Thead borderRadius={"10px"} height={"40px"}  >
      <Tr>
        {columns.map((column: any) => {
          return renderTh(column)
        }
        )}
        {extraCols > 0 && renderExtraCols()}
      </Tr>
    </Thead>
  )
}

export default TableHeader
